import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Spark EUV Configurator (linkId 2372).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2372.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape. Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    SparkEUV: {
      id: 'SparkEUV',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      backgroundIdentifer: 'dome',
      variants: {
        'activ-fwd': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5468',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'common_interior',
              sku: '5462',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5476',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5482',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'variants_parts',
              sku: '5466',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7077',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        }
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '7077',
          project: '59'
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '7078',
          project: '59'
        }
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: []
      },
      colors: {
        interior: {
          '1ahry6ef040l': {
            sku: '5476',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ],
            notCompatibleExteriorColors: []
          },
          a1e1txmplnmz: {
            sku: '5472',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ],
            notCompatibleExteriorColors: []
          }
        },
        exterior: {
          k550ufl2z63j: {
            sku: '5482',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          },
          gxqxsxnaljfj: {
            sku: '5469',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          },
          '9i25yo15msgi': {
            sku: '5465',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          },
          l415icrduyfe: {
            sku: '5473',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          },
          t0ah6d0ze4xe: {
            sku: '5461',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          },
          ew6nnknehod1: {
            sku: '5460',
            project: '59',
            relevantVariants: [
              'activ-fwd'
            ]
          }
        }
      },
      features: {
        ylam62d7djz9: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_LED headlamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'LED headlamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kh1xk6tsachv: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1slkxz7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'LED Tail Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'Shader_LED Tail Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k1gebz2rhrfs: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Smart Charging',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kbns5f4ez323: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Roof Rails',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Rails',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y6zcqp9r8fln: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'Shader_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xsdac8nojc1s: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Modern Interior',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Modern Interior',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ddlwz0n6pzn89: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Smart_Space',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Shader_Smart_Space_Top',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Smart_Space',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k1gebz2rhrfs7: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Smart Charging',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ddlwz0n6pzn8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Versatile Space',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Versatile Space',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: true,
              snapToLastFrame: false
            }
          }
        },
        '9cffzj69hili': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Driving Mode',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Driving Mode',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '9cffzj69hilli': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'activ-fwd'
          ],
          messages: [
            {
              message: 'Shader_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: '360 Camera',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        }
      },
      accessories: {
        '0agqewqxtxza': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front_Body_Kit',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Front_Body_Kit',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Front_Body_Kit',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        an4yb9ia2pck: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Rear_Body_Kit',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Rear_Body_Kit',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Rear_Body_Kit',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xfkdiah0cnde: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tapbu8okt0uj: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Side_Molding',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Side_Molding',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Side_Molding',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4by5qhwuy594': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Rear_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Rear_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Rear_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mr7qy5fo5qhm: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Front_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Front_Storage_Box',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            sp7oz1hgrlpw: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wf9709z90ina: {
          view: 'exterior',
          groupId: 'activ-fwd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Chevrolet_Front_Script_Nameplate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Chevrolet_Front_Script_Nameplate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Chevrolet_Front_Script_Nameplate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '992852zsh6q9': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Puddle_Lamp',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Puddle_Lamp',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Puddle_Lamp',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4ort1u09q912': {
          view: 'exterior',
          groupId: 'activ-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Gaming_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          resyncInteractionsOnApply: [
            'sp7oz1hgrlpw'
          ],
          cameraMessages: [
            {
              message: 'Camera_Gaming_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        myd4cnt41hwx: {
          view: 'exterior',
          groupId: 'activ-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Camo_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          resyncInteractionsOnApply: [
            'sp7oz1hgrlpw'
          ],
          cameraMessages: [
            {
              message: 'Camera_Camo_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        d5bu0trex0kw: {
          view: 'exterior',
          groupId: 'activ-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Adventure_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          resyncInteractionsOnApply: [
            'sp7oz1hgrlpw'
          ],
          cameraMessages: [
            {
              message: 'Camera_Adventure_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ei4h2im8ratx: {
          view: 'exterior',
          groupId: 'activ-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Active_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          resyncInteractionsOnApply: [
            'sp7oz1hgrlpw'
          ],
          cameraMessages: [
            {
              message: 'Camera_Active_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4fjgp644j9510': {
          view: 'exterior',
          groupId: 'activ-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Retro_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          resyncInteractionsOnApply: [
            'sp7oz1hgrlpw'
          ],
          cameraMessages: [
            {
              message: 'Camera_Retro_Theme',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            },
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4fjgp644j954': {
          view: 'exterior',
          groupId: 'activ-fwd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Default_Logo',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'activ-fwd'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        }
      },
      packages: {},
      interactions: {
        xbdzchklx04d: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'activ-fwd'
          ]
        },
        sp7oz1hgrlpw: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'BONNET_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'BONNET_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'activ-fwd'
          ],
          availableFor: {
            accessories: [
              'mr7qy5fo5qhm'
            ]
          }
        },
        '9a4ewd0iqpwk': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'activ-fwd'
          ]
        },
        bkr8amy2tvbs: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'activ-fwd'
          ]
        },
        '6146uzbd6kui': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'activ-fwd'
          ]
        },
        iq7p37hq4g0j: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'activ-fwd'
          ]
        }
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0
            },
            isFovZoomModeOn: false
          }
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {}
        }
      },
      usdzPathWithVariable: ''
    }
  }
};
